import type { PostQuizAnalyticsBody } from '@vue-quiz-app/types/quiz';

const API_URL = import.meta.env.VITE_API_URL || window.location.origin;

export async function getXCSRFToken() {
  return await fetch(`${API_URL}/session/token`, { credentials: 'include' }).then((response) => response.json());
}

export async function postQuizAnalytics(body: PostQuizAnalyticsBody) {
  return await fetch(`${API_URL}/api/quiz/statistics`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
}
